import React, { useState } from 'react';
import { translate } from '../Services/translation';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch } from 'react-redux';
import { query, saveQuery } from '../Actions/FacetedSearch.action';
import { colors } from '../mui-theme';

export const ProductListRowsPerPage = ({ rowsPerPage }) => {
    const dispatch = useDispatch();

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const paramName = 'rowsperpages';

    const defaultOption = searchParams.get(paramName) ?? rowsPerPage?.defaultOption;
    const [selectedOption, setSelectedOption] = useState(defaultOption);

    const options = rowsPerPage?.rowOptions.map((item) => ({
        value: item,
        label: item,
    }));

    const handleChange = (event) => {
        setSelectedOption(event.target.value);
        searchParams.set(paramName, event.target.value); // Update the parameter with the selected value
        url.search = searchParams.toString(); // Update the URL's search string

        dispatch(saveQuery(url.search.substring(1)));
        dispatch(query(url.search.substring(1)));
    };

    return (
        <div className="selected-filter__row-options-wrapper">
            <span className="selected-filter__row-options-label">{translate('code.products.rowsperpage')}</span>
            <FormControl
                variant="standard"
                sx={{ m: 1, minWidth: 50 }}
            >
                <Select
                    id="rows-per-page"
                    value={selectedOption}
                    onChange={handleChange}
                    label="Rows per page"
                    sx={{
                        '&::after': {
                            borderBottom: '2px solid' + colors.colorprimary100,
                        },
                    }}
                >
                    {options.map((item, index) => (
                        <MenuItem
                            key={index}
                            value={item.value}
                        >
                            {item.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
};
